<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-header>
                    <span class="h5">
                        PROJETO -
                        <b-badge variant="warning">{{ operacao }}</b-badge>
                    </span>
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <b-col sm="12" md="4">
                            <app-k-v
                                titulo="Código"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.codProjeto"
                            ></app-k-v>
                            <app-k-v
                                titulo="Projeto"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.projeto"
                            ></app-k-v>
                            <app-k-v
                                titulo="Modulo"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.modulo"
                            ></app-k-v>
                            <app-k-v
                                titulo="Unidade"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.unidade"
                            ></app-k-v>
                            <app-k-v
                                titulo="Gestor"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.gestor"
                            ></app-k-v>
                            <app-k-v
                                titulo="Gerente"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.gerente"
                            ></app-k-v>
                            <app-k-v
                                titulo="Fornecedor"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.credenciado"
                            ></app-k-v>
                        </b-col>
                        <b-col sm="12" md="4">
                            <app-k-v
                                titulo="Ficha Técnica"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.fichaTecnica"
                            ></app-k-v>
                            <app-k-v
                                titulo="Qtd Etapas"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.qtdEtapas"
                            ></app-k-v>
                            <app-k-v
                                titulo="Total Horas"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.totalHoras"
                            ></app-k-v>
                            <app-k-v
                                titulo="Valor Total"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    projeto.valorTotal | currency
                                }}</strong>
                            </app-k-v>
                        </b-col>
                        <b-col sm="12" md="4">
                            <app-k-v
                                titulo="Descricao Demanda"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.descricaoDemanda"
                            ></app-k-v>
                            <app-k-v
                                titulo="Contratação"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.tipoContratacao"
                            ></app-k-v>
                            <app-k-v
                                titulo="Area"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.descricaoArea"
                            ></app-k-v>
                            <app-k-v
                                titulo="Sub Area"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.descricaoSubArea"
                            ></app-k-v>
                            <app-k-v
                                titulo="Solução"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="projeto.descricaoSolucao"
                            ></app-k-v>
                        </b-col>
                    </b-row>
                    <convenioDetalhar :projeto="projeto"></convenioDetalhar>
                </b-card-body>
                <b-card-footer>
                    <slot name="footer" v-bind="projeto"></slot>
                </b-card-footer>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import convenioDetalhar from '../convenioDetalhar'

export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            xl: 3,
            lg: 3,
            md: 2
        }
    },

    computed: {},

    components: {
        convenioDetalhar
    }
}
</script>
